export const isMinLength = (length) => {
  const func = (val) => (val || "").length >= length;
  return func;
};

export const isEmail = (val) => {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(val);
};

export const isPhone = (val) => {
  if (!val || !String(val).trim()) return true;
  const digits = String(val).replace(/\D/g, "");
  return digits.length === 10 || (digits.length === 11 && digits[0] === "1");
};
